$(".logo-slider-scroll").slick({
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1200,
  centerMode: true,
  arrows: false,
  slidesToShow: 6,
  slidesToScroll: 1.5,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
});
document.addEventListener("DOMContentLoaded", function () {
  let sliderContainers = document.querySelectorAll(".mobile-slider_grid"); // Parent selector for each slider and bullets

  if (sliderContainers.length) {
    sliderContainers.forEach((container) => {
      let slider = container.querySelector(".product-list"); // Slider within the container
      let bullets = container.querySelectorAll("page-dots button"); // Bullets within the container

      if (slider && bullets.length) {
        // Function to update the active bullet
        function updateBullets(index) {
          bullets.forEach((bullet, i) => {
            bullet.setAttribute("aria-current", i === index ? "true" : "false");
          });
        }

        // Detect current slide index based on slider position
        function getCurrentSlideIndex() {
          let slideWidth = slider.offsetWidth; // Width of one slide
          return Math.round(slider.scrollLeft / slideWidth); // Calculate the current slide index
        }

        // Listen for slider scroll events to update bullets
        slider.addEventListener("scroll", () => {
          let currentIndex = getCurrentSlideIndex();
          updateBullets(currentIndex); // Update bullet points
        });

        // Add click event listeners to bullets for manual navigation
        bullets.forEach((bullet, index) => {
          bullet.addEventListener("click", () => {
            let slideWidth = slider.offsetWidth;
            slider.scrollTo({
              left: slideWidth * index, // Scroll to the selected slide
              behavior: "smooth", // Smooth scrolling
            });
            updateBullets(index); // Update bullet points
          });
        });
      } else {
        console.warn("Slider or bullets not found in one of the containers!");
      }
    });
  } else {
    console.error("No `.mobile-slider_grid` containers found!");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Add active class to the closest .gift-card-section when .gift-card-block is clicked
  document.querySelectorAll(".gift-card-block").forEach((block) => {
    block.addEventListener("click", function () {
      this.closest(".gift-card-section")?.classList.toggle("active");
    });
  });

  // Remove active class from all .gift-card-section elements when #add-button is clicked
  document.querySelector("#add-button")?.addEventListener("click", function () {
    document
      .querySelectorAll(".gift-card-section.active")
      .forEach((section) => {
        section.classList.remove("active");
      });
  });
});
document.getElementById("cancel-button").addEventListener("click", function () {
  // Clear input fields
  document.querySelector('.custom-message-box [name="properties[To]"]').value =
    "";
  document.querySelector(
    '.custom-message-box [name="properties[From]"]'
  ).value = "";
  document.querySelector(
    '.custom-message-box [name="properties[Message]"]'
  ).value = "";
  document.querySelector(
    '.product-info__buy-buttons [name="properties[To]"]'
  ).value = "";
  document.querySelector(
    '.product-info__buy-buttons [name="properties[From]"]'
  ).value = "";
  document.querySelector(
    '.product-info__buy-buttons [name="properties[Message]"]'
  ).value = "";
  document.querySelector(
    '.product-info__buy-buttons [name="properties[Gift Card]"]'
  ).value = "";

  // Uncheck all radio buttons for "properties[Gift Card]"
  document
    .querySelectorAll('.radio-group [name="properties[Gift Card]"]')
    .forEach((radio) => {
      radio.checked = false;
    });
  document
    .querySelectorAll(".gift-card-section.active")
    .forEach((show_gift) => {
      show_gift.classList.remove("active");
    });
});
document.addEventListener("DOMContentLoaded", function () {
  // Function to sync input values
  function syncInput(sourceSelector, targetSelector) {
    document
      .querySelector(sourceSelector)
      .addEventListener("input", function () {
        document.querySelector(targetSelector).value = this.value;
      });
  }

  // Sync To, From, and Message fields
  syncInput(
    '.custom-message-box [name="properties[To]"]',
    '.product-info__buy-buttons [name="properties[To]"]'
  );
  syncInput(
    '.custom-message-box [name="properties[From]"]',
    '.product-info__buy-buttons [name="properties[From]"]'
  );
  syncInput(
    '.custom-message-box [name="properties[Message]"]',
    '.product-info__buy-buttons [name="properties[Message]"]'
  );

  // Sync radio button value for "Gift Card" (without checking it)
  document
    .querySelectorAll('.custom-message-box [name="properties[Gift Card]"]')
    .forEach((radio) => {
      radio.addEventListener("change", function () {
        document.querySelector(
          '.product-info__buy-buttons [name="properties[Gift Card]"]'
        ).value = this.value;
      });
    });
});
